import { __awaiter } from "tslib";
import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import { getMessaging, getToken, onMessage } from '@firebase/messaging';
const firebaseConfig = {
    apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
    authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
    projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.VUE_APP_FIREBASE_APP_ID,
    measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID
};
export default {
    install: (app) => {
        // Initialize Firebase
        const firebaseApp = initializeApp(firebaseConfig);
        const analytics = getAnalytics(firebaseApp);
        app.config.globalProperties.$config = Object.freeze(Object.assign({}, analytics));
    }
};
initializeApp(firebaseConfig);
const messaging = getMessaging();
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const onMessageReceived = (callback) => {
    onMessage(messaging, callback);
};
export const requestPermissionAndGetToken = (vapidKey) => __awaiter(void 0, void 0, void 0, function* () {
    const permission = yield Notification.requestPermission();
    if (permission === 'granted') {
        const token = yield getToken(messaging, { vapidKey });
        return token;
    }
    else {
        throw new Error('Permission not granted');
    }
});
